import React, { useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { FormGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import SubmitPopupModal from './SubmitPopupModal';
import MultiProductCostingSubmitModal from '../MultiProductCostingSubmit/MultiProductCostingSubmitModal';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { isSameSupplierExist } from '../../store/DevelopmentOrder.action';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';
import { SubmitAndDownloadIcon } from '../../../../bombiix-icon';
import { FloatyButton } from '../../../../Components/Floaty';

function SubmitAndDownload({ mainStateData, setMainState }) {
  const [state, setState] = useState({
    selectedType: '',
    show: false,
    commonSupplierList: [],
    productData: [],
  });

  const [productCostingState, setProductCostingState] = useState({
    show: false,
    commonSupplierList: [],
    productData: [],
  });

  const {
    UserDetails: { userRole },
    Users: { logInRights },
  } = useSelector((reducerState) => reducerState);

  const { show } = state;
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation('common');
  const { selectedIds } = mainStateData;
  const SubmitRights = userRole === 'User' ? logInRights?.[0]?.submitTechPack : true;
  const downloadRights = userRole === 'User' ? logInRights?.[0]?.downloadTechPack : true;

  const handleChangeList = async (val) => {
    const obj = {
      devOrderIds: selectedIds,
    };
    if (selectedIds.length > 0) {
      const res = await dispatch(isSameSupplierExist(obj));
      if (res?.data?.supplierData && res?.data?.supplierData?.length > 0) {
        const setList = (arr) => {
          const arrs = cloneDeep(arr);
          return arrs.map((val) => {
            return { ...val, value: val.name, label: val.name };
          });
        };
        if (val === 'productCosting') {
          setProductCostingState((prev) => ({
            ...prev,
            show: true,
            commonSupplierList: setList(res.data.supplierData),
            productData: res?.data?.doc || [],
          }));
        } else {
          setState((prev) => ({
            ...prev,
            selectedType: val,
            show: true,
            commonSupplierList: setList(res.data.supplierData),
            productData: res?.data?.doc || [],
          }));
        }
      } else {
        if (selectedIds?.length === 1) {
          toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_DOWNLOAD.SUPLIER_NOT_EXIST'), 'danger');
          return;
        }
        toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_DOWNLOAD.SUPLIER_SAME_EXIST'), 'danger');
      }
    } else {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_DOWNLOAD.PLEASE_SELECT_PRODUCT'), 'danger');
    }
  };

  const handleMultiSubmit = async () => {
    if (selectedIds.length === 0) {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_DOWNLOAD.PLEASE_SELECT_PRODUCT'), 'danger');
      return;
    }
    const res = await dispatch(isSameSupplierExist({ devOrderIds: selectedIds }));
    if (res?.data?.supplierData && res?.data?.supplierData?.length > 0) {
      history.push(`/development-order-overview/multi-submit?ids=${selectedIds.join(',')}`);
    } else if (selectedIds?.length === 1) {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_DOWNLOAD.SUPLIER_NOT_EXIST'), 'danger');
    } else {
      toasterMsg(t('DEVLOPMENT_ORDER.PRODUCT_INFORMATIONS.SUBMIT_POPUP.SUBMIT_DOWNLOAD.SUPLIER_SAME_EXIST'), 'danger');
    }
  };

  const toggle = () => {
    setState((prev) => ({ ...prev, show: false }));
  };

  const productCostingToggle = () => {
    setProductCostingState((prev) => ({ ...prev, show: false }));
  };

  return (
    <>
      <OverlayTrigger
        placement="top"
        trigger="click"
        rootClose
        overlay={
          <Popover className="custom-popover submit-download-popover">
            <Popover.Content>
              <FormGroup className="mb-0">
                <ul>
                  {SubmitRights && (
                    <li onClick={handleMultiSubmit} className="mb-14">
                      <span className="text-decoration-underline">{t('SETUP_2FA.SUBMIT')}</span>
                    </li>
                  )}
                  {downloadRights && (
                    <li onClick={(e) => handleChangeList('Download')} className="mb-14">
                      <span className="text-decoration-underline">{t('PURCHASE_ORDER_NUMBER.DOWNLOADING')}</span>
                    </li>
                  )}
                </ul>
              </FormGroup>
            </Popover.Content>
          </Popover>
        }
      >
        <FloatyButton
          icon={SubmitAndDownloadIcon}
          label={t('TAKING_DATES.SUBMIT_DOWNLOAD')}
          disabled={selectedIds?.length === 0}
          showTooltip={false}
        />
      </OverlayTrigger>

      {show && <SubmitPopupModal listState={mainStateData} mainState={state} toggle={toggle} setMainState={setMainState} />}

      {productCostingState.show && (
        <MultiProductCostingSubmitModal
          mainState={productCostingState}
          toggle={productCostingToggle}
          listState={mainStateData}
          setMainState={setMainState}
          setProductCostingState={setProductCostingState}
        />
      )}
    </>
  );
}

export default SubmitAndDownload;
